// extracted by mini-css-extract-plugin
export default {"staticFieldContainer":"StaticField_staticFieldContainer__SIosO","fieldValue":"StaticField_fieldValue__TtVwP","fieldLabel":"StaticField_fieldLabel__cgeJn"};